export default class MoveInDate {
  static get OneToTwoMonths() {
    return new MoveInDate('1-2');
  }

  static get ThreeToSixMonths() {
    return new MoveInDate('3-6');
  }

  static get BuildablePlans() {
    return new MoveInDate(null);
  }

  constructor(name) {
    this.name = name;
  }

  toString() {
    return `${this.name}`;
  }
}
